import { Avatar, IconButton } from "@ligo/layout-design-core";
import styled from "styled-components";

type MenuStyleType = {
  $isCollapsed: boolean;
};

type ProfileAvatarStyleType = {
  $inPause?: boolean;
};

export const NavContent = styled.nav`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  a {
    text-decoration: none;
  }
`;

export const NavButton = styled(IconButton).attrs({
  $outlined: true,
  className: "collapse-button",
})<MenuStyleType>`
  z-index: 15;
  opacity: 0;
  pointer-events: none;
  transition: opacity ease-in-out 0.2s;

  position: absolute;
  top: 2.4rem;
  right: -1.2rem;
  transform: ${({ $isCollapsed }) =>
    $isCollapsed ? "rotate(180deg)" : "initial"};

  width: 2.4rem;
  height: 2.4rem;
  border: 0.1rem solid var(--gray);
  background: var(--white);
  color: var(--text);
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileAvatar = styled(Avatar)<ProfileAvatarStyleType>`
  width: 3.6rem;
  height: 3.6rem;
  position: relative;
  overflow: initial;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 1rem;
    height: 1rem;
    border-radius: 0.5rem;
    border: 0.1rem solid var(--white);
    background-color: ${({ $inPause }) =>
      $inPause ? "var(--red)" : "var(--green)"};
  }
`;

export const SideBarContainer = styled.header<MenuStyleType>`
  height: 100%;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "7.2rem" : "24.6rem")};
  position: relative;
  transition: width ease-in-out 0.5s;

  &:hover > .collapse-button {
    opacity: 1;
    pointer-events: initial;
  }

  > div {
    height: 100%;
    max-height: 100%;
    overflow: ${({ $isCollapsed }) => ($isCollapsed ? "initial" : "auto")};
    background: var(--neutral);
    padding: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;

    a,
    a:hover,
    a:focus {
      text-decoration: none;
    }

    > svg {
      max-width: 100%;
      min-height: 4rem;
    }
  }
`;
